const IconContainer = ({ children }) => {
  return <div className="icon-container border border-1">{{ children }}</div>;
};

export default IconContainer;
